import React, { useState, useMemo } from 'react';
import {
  Box,
  Typography,
  useTheme,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  TextField,
  CircularProgress,
} from '@mui/material';
import { useGetAgentsQuery } from 'state/managementApi';

// Filter out manager, admin, and superadmin roles - only show viewable users
const VIEWABLE_ROLES = ['salesAgent', 'customer', 'agent', 'dispatch'];

const ViewAsUser = ({ onUserSelect, onExitView }) => {
  const theme = useTheme();
  const { data: agents, isLoading } = useGetAgentsQuery(null, { staleTime: 0 });
  const [selectedUserId, setSelectedUserId] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  
  const filteredAgents = useMemo(() => {
    if (!agents) return [];
    return agents.filter(agent =>
      VIEWABLE_ROLES.includes(agent.role) &&
      agent.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [agents, searchTerm]);

  return (
    <Box sx={{ backgroundColor: theme.palette.background.alt, p: 3, borderRadius: '7px', width: '100%', maxWidth: '500px', margin: '2rem auto' }}>
      <Typography variant="h6" gutterBottom>
        View Dashboard As
      </Typography>
      <FormControl fullWidth>
        <InputLabel id="user-select-label">Select User</InputLabel>
        <Select
          labelId="user-select-label"
          value={selectedUserId}
          label="Select User"
          onChange={(e) => setSelectedUserId(e.target.value)}
          onClose={() => setSearchTerm('')} // Clear search on close
        >
          <Box sx={{ p: 1, borderBottom: '1px solid #ccc' }}>
            <TextField
              fullWidth
              variant="standard"
              placeholder="Search users..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onClick={(e) => e.stopPropagation()} // Prevents dropdown from closing
            />
          </Box>
          {isLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
              <CircularProgress />
            </Box>
          ) : (
            filteredAgents.map((agent) => (
              <MenuItem key={agent._id} value={agent._id}>
                {agent.name} - ({agent.role})
              </MenuItem>
            ))
          )}
        </Select>
      </FormControl>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, gap: 1 }}>
        <Button
          variant="outlined"
          color="secondary"
          onClick={onExitView}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={!selectedUserId}
          onClick={() => onUserSelect(selectedUserId)}
        >
          View Dashboard
        </Button>
      </Box>
    </Box>
  );
};

export default ViewAsUser;